var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1372_26881)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.00488281)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1372_26881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 8.00415C15.9995 10.1259 15.1567 12.1607 13.6564 13.661C12.1561 15.1613 10.1212 16.0042 7.99951 16.0042C5.87778 16.0042 3.84295 15.1613 2.34266 13.661C0.842367 12.1607 -0.000488281 10.1259 -0.000488281 8.00415C-0.000488281 5.88242 0.842367 3.84759 2.34266 2.3473C3.84295 0.847005 5.87778 0.00415039 7.99951 0.00415039C10.1212 0.00415039 12.1561 0.847005 13.6564 2.3473C15.1567 3.84759 15.9995 5.88242 15.9995 8.00415ZM8.49951 4.50415C8.49951 4.37154 8.44683 4.24437 8.35307 4.1506C8.2593 4.05683 8.13212 4.00415 7.99951 4.00415C7.8669 4.00415 7.73973 4.05683 7.64596 4.1506C7.55219 4.24437 7.49951 4.37154 7.49951 4.50415V7.50415H4.49951C4.3669 7.50415 4.23973 7.55683 4.14596 7.6506C4.05219 7.74437 3.99951 7.87154 3.99951 8.00415C3.99951 8.13676 4.05219 8.26394 4.14596 8.3577C4.23973 8.45147 4.3669 8.50415 4.49951 8.50415H7.49951V11.5042C7.49951 11.6368 7.55219 11.7639 7.64596 11.8577C7.73973 11.9515 7.8669 12.0042 7.99951 12.0042C8.13212 12.0042 8.2593 11.9515 8.35307 11.8577C8.44683 11.7639 8.49951 11.6368 8.49951 11.5042V8.50415H11.4995C11.6321 8.50415 11.7593 8.45147 11.8531 8.3577C11.9468 8.26394 11.9995 8.13676 11.9995 8.00415C11.9995 7.87154 11.9468 7.74437 11.8531 7.6506C11.7593 7.55683 11.6321 7.50415 11.4995 7.50415H8.49951V4.50415Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1372_26881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00488281)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1372_26881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconWhite);
export default __webpack_public_path__ + "static/media/add_icon_white.2a77daec8a15e468cf9fea0f25cc8eb9.svg";
export { ForwardRef as ReactComponent };